import { create } from 'zustand';
import { getMissedCallsCount, acknowledgeMissedCalls } from '@/lib/missed-calls-api';

interface MissedCallsState {
  count: number;
  pollingInterval: ReturnType<typeof setInterval> | null;

  // Actions
  fetchCount: () => Promise<void>;
  acknowledgeAll: () => Promise<void>;
  increment: () => void;
  startPolling: (intervalMs?: number) => void;
  stopPolling: () => void;
}

export const useMissedCallsStore = create<MissedCallsState>((set, get) => ({
  count: 0,
  pollingInterval: null,

  fetchCount: async () => {
    try {
      const { count } = await getMissedCallsCount();
      set({ count });
    } catch (error) {
      console.error('Failed to fetch missed calls count', error);
    }
  },

  acknowledgeAll: async () => {
    try {
      await acknowledgeMissedCalls();
      set({ count: 0 });
    } catch (error) {
      console.error('Failed to acknowledge missed calls', error);
    }
  },

  increment: () => {
    set((s) => ({ count: s.count + 1 }));
  },

  startPolling: (intervalMs = 60000) => {
    const { pollingInterval, fetchCount } = get();

    // Clear existing interval if any
    if (pollingInterval) {
      clearInterval(pollingInterval);
    }

    // Initial fetch
    fetchCount();

    // Start polling
    const interval = setInterval(() => {
      fetchCount();
    }, intervalMs);

    set({ pollingInterval: interval });
  },

  stopPolling: () => {
    const { pollingInterval } = get();
    if (pollingInterval) {
      clearInterval(pollingInterval);
      set({ pollingInterval: null });
    }
  },
}));
